const htmlToTextInternal = (node: HTMLElement, buffer: Array<string>): Array<string> => {
	for (const child of node.childNodes) {
		if (child instanceof Text) {
			buffer.push(child.textContent!)
		} else if (child instanceof HTMLElement) {
			if (child instanceof HTMLAnchorElement) {
				htmlToTextInternal(child, buffer)

				buffer.push(` (${child.href})`)
			} else if (child instanceof HTMLLIElement) {
				buffer.push('* ')

				htmlToTextInternal(child, buffer)
			} else if (child instanceof HTMLParagraphElement) {
				htmlToTextInternal(child, buffer)
				buffer.push('\n', '\n')
			} else {
				htmlToTextInternal(child, buffer)
			}

			const { display } = getComputedStyle(child)

			if (buffer.at(-1) !== '\n' && !/\binline\b/i.test(display)) {
				buffer.push('\n')
			}
		}
	}

	return buffer
}

/**
 * Simplfied html-to-text converter.
 */
export const htmlToText = (node: HTMLElement) => htmlToTextInternal(node, []).join('')
